




















import { Component, Vue, Prop, Inject, Ref } from 'vue-property-decorator';
import * as calc from '@/app/order-calculations-interface';
import Order from './Order.vue';
import SAmountInput from '@/components/UI/Form/SAmountInput.vue';
import { WatchObjectAsJson } from '@/decorators/watch-object-as-json';
import Decimal from '@/utils/decimal';

@Component
export default class OrderLineAllowanceCharge extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public line!: any;
  @Inject() public documentComponent!: Order;
  @Ref() public readonly inputRef!: SAmountInput;

  public created() {
    if (!this.line.orderLineAllowanceCharge) {
      this.line.orderLineAllowanceCharge = {
        id: null,
        orderLineId: this.line.id,
        reason: '',
        percent: new Decimal(0),
        amount: new Decimal(0),
      };
    }
  }

  get editable() {
    return this.documentComponent.reactiveProps.editable;
  }

  get listeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  get isPositive() {
    return this.line.orderLineAllowanceCharge.percent.isPositive();
  }

  get isZero() {
    return this.line.orderLineAllowanceCharge.percent.isZero();
  }

  public handleFocus() {
    if (this.isZero) {
      // The one thousandth is going to be rounded when put into the input,
      // and will be emitted back as 0, so it doesn't affect the calculation,
      // but it will have the minus in the input, which is preferred here.
      this.line.orderLineAllowanceCharge.percent = new Decimal(-0.001);
    }

    if (this.isPositive) {
      this.inputRef.select();
    } else {
      this.inputRef.selectAllButFirst();
    }
  }

  @WatchObjectAsJson('line')
  public calculate() {
    (this.line as calc.IOrderLine).orderLineAllowanceCharge!.amount =
      calc.orderLineAllowanceChargeAmount(
        (this.line as calc.IOrderLine).orderLineAllowanceCharge!,
        this.line as calc.IOrderLine,
      );
  }
}
